import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as Diff2Html from 'diff2html';
import { withTranslation } from 'react-i18next';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import AppModal from '../../../components/Modal';
import ApiV2ModelContext from '../../../contexts/ApiV2ModelContext';
export const withQuickFixesForPullRequestModal = (WrappedComponent) => {
    var _a;
    return withTranslation()((_a = class QuickFixesForPullRequesModal extends React.Component {
            constructor() {
                super(...arguments);
                this.state = {
                    open: false,
                    files: [],
                    quickFixesForPR: {},
                    prCreated: false,
                    pullRequestTitle: '',
                    pullRequestBranchName: '',
                };
                this.handleCloseModal = () => {
                    this.setState({ open: false });
                };
                this.handleClick = (quickFixesForPR) => {
                    this.setState({
                        open: true,
                        files: quickFixesForPR.files,
                        quickFixesForPR,
                        pullRequestTitle: quickFixesForPR.pullRequestTitle,
                        pullRequestBranchName: quickFixesForPR.pullRequestBranchName,
                    });
                };
                this.handleGeneratePR = async () => {
                    const { quickFixesForPR, pullRequestTitle, pullRequestBranchName } = this.state;
                    try {
                        const response = await this.context.generatePullRequestFromDiff({ ...quickFixesForPR, pullRequestTitle, pullRequestBranchName });
                        this.setState({ prCreated: response.generatePullRequestFromDiff?.status });
                    }
                    catch (error) {
                        console.log('error', error);
                    }
                };
                this.handleChangeTitle = (event) => {
                    this.setState({
                        pullRequestTitle: event.target.value,
                    });
                };
                this.handleChangeBranch = (event) => {
                    this.setState({
                        pullRequestBranchName: event.target.value,
                    });
                };
            }
            renderModal() {
                const { files, prCreated, quickFixesForPR } = this.state;
                const { t } = this.props;
                // @todo: Verify if we don't need all the commented type incompatible properties.
                const config = {
                    //inputFormat: 'json',
                    drawFileList: false,
                    //fileListToggle: false,
                    //fileListStartVisible: false,
                    //fileContentToggle: false,
                    matching: 'lines',
                    outputFormat: 'line-by-line',
                    //synchronisedScroll: true,
                    //highlight: true,
                    renderNothingWhenEmpty: false,
                    maxLineSizeInBlockForComparison: 100,
                };
                return (_jsxs(Modal, { isOpen: true, toggle: this.handleCloseModal, autoFocus: false, size: "xl", modalClassName: "repositories-modal", contentClassName: "repositories-modal__content", children: [_jsx(ModalHeader, { toggle: this.handleCloseModal, children: t('quickFixModalHeader') }), _jsx(ModalBody, { children: _jsxs("div", { className: "container reports mt-3", children: [_jsxs("form", { className: 'pb-2', children: [_jsxs("p", { children: [_jsx("label", { htmlFor: "pullRequestTitle", children: t('pullRequestTitle') }), _jsx("input", { type: "text", id: "pullRequestTitle", className: "form-control" //+ (browser.greaterThan.small ? ' form-control-lg' : '')}
                                                        , placeholder: t('pullRequestTitle'), defaultValue: quickFixesForPR ? quickFixesForPR.pullRequestTitle : '', onChange: this.handleChangeTitle, required: true, autoFocus: true })] }), _jsxs("p", { children: [_jsx("label", { htmlFor: "pullRequestBranchName", children: t('pullRequestBranchName') }), _jsx("input", { type: "text", id: "pullRequestBranchName", className: "form-control" //+ (browser.greaterThan.small ? ' form-control-lg' : '')}
                                                        , placeholder: t('pullRequestBranchName'), defaultValue: quickFixesForPR ? quickFixesForPR.pullRequestBranchName : '', onChange: this.handleChangeBranch, required: true, autoFocus: true })] })] }), files.length && files.map((file) => (_jsxs("div", { className: "report-detail__item", id: file.path, children: [_jsxs("h3", { className: "report-detail__file-path pl-0", children: [_jsx("small", { className: "text-muted", children: _jsx("span", { className: "badge badge-pill badge-primary ml-3", children: file.fixTool }) }), _jsx("bdi", { id: "report-path", children: file.path })] }), _jsx("div", { id: "code-diff", dangerouslySetInnerHTML: { __html: Diff2Html.html(file.fixDiff, config) } })] }, file.path))), prCreated ? (_jsx("div", { className: 'maintenance-banner alert alert-success', children: _jsx("span", { children: t('pullRequestWasCreated') }) })) : (_jsx("div", { className: "text-right", children: _jsx("button", { className: "btn btn-primary", onClick: this.handleGeneratePR, children: t('generatePullRequest') }) }))] }) })] }));
            }
            render() {
                return (_jsxs("div", { children: [_jsx(WrappedComponent, { ...this.props, onShowDiffClick: this.handleClick }), this.state.open && _jsx(AppModal, { children: this.renderModal() })] }));
            }
        },
        _a.contextType = ApiV2ModelContext,
        _a));
};
